import { createFileRoute } from "@tanstack/react-router";
import PlansConfigurations from "@/components/plans/plans-configuration";
import { modulesTypes } from "@/convex/system/permissions";

export const Route = createFileRoute("/_super/super/plans")({
  component: PlansPage,
});

function PlansPage() {
  return <PlansConfigurations module={modulesTypes.type} />;
}